var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5047 12.1134L11.4665 9.07515C11.2738 8.88252 10.9616 8.88252 10.769 9.07515L10.5978 9.24634L9.69876 8.34727C11.1359 6.2734 10.9309 3.40581 9.08364 1.55852C7.00561 -0.519508 3.63649 -0.519508 1.5585 1.55852C-0.519477 3.63655 -0.519526 7.00568 1.5585 9.08366C3.40584 10.931 6.27338 11.1359 8.34725 9.69878L9.24632 10.5978L9.07512 10.769C8.8825 10.9616 8.8825 11.2739 9.07512 11.4665L12.1134 14.5047C12.7737 15.1651 13.8444 15.1651 14.5048 14.5047C15.1651 13.8444 15.1651 12.7737 14.5047 12.1134ZM2.34516 8.29696C0.704276 6.65608 0.704276 3.98615 2.34511 2.34527C3.98603 0.704391 6.65601 0.704343 8.29684 2.34522C9.93777 3.9861 9.93777 6.65608 8.29684 8.29696C7.47643 9.11742 6.39871 9.52763 5.321 9.52763C4.24328 9.52763 3.16557 9.11742 2.34516 8.29696Z",
    fill: "#BAB7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.ea0edb126a4984e29f4866bcb364f259.svg";
export { ForwardRef as ReactComponent };